module.exports = __webpack_public_path__ + "94014b662ef718106e7aacff11e1115b.pdf";